import React, { useEffect, useState } from "react";
import { Container, FirstCard, SecondCard, Form, Field, Heading, Mfield2, Mfield1, Spacediv, DropDiv, Heading2, Icon, InputFile, DropDiv2, InputFileManual, Button1, Button2, Buttons, ButtonsDiv, ImageContainer, RemoveIcon, Image, Imagecsv, Arroba } from "./style";

import Input from "../../Input";
import api from "../../../Services/api";
import { useNavigate } from "react-router-dom";
import Button from "../../Button";
import Swal from "sweetalert2";
import { Alert } from "../../../utils/Alert";
import InputSelect from "../../Select";
import Icone from "../../../utils/Icone";

export default function CadastroManual({ setShow, Show }) {
  if (!Show) return;
  const [Nome, setNome] = useState("");
  const [RM, setRM] = useState("");
  const [Email, setEmail] = useState("");
  const [Curso, setCurso] = useState("");
  const [DataNascimento, setDataNascimento] = useState("");
  const [DataInicio, setDataInicio] = useState("");
  const [DataTermino, setDataTermino] = useState("");
  const [Convenio, setConvenio] = useState("");
  const [NomeAnexo, setNomeAnexo] = useState("");

  const [FileImg, setFileImg] = useState("");
  const [NomeArquivo, setNomeArquivo] = useState("");
  const [Tipo, setTipo] = useState("");
  const [File, setFile] = useState("");

  const [FileManual, setFileManual] = useState("");
  const [NomeArquivoManual, setNomeArquivoManual] = useState("");
  const [TipoManual, setTipoManual] = useState("");
  const [FileImgManual, setFileImgManual] = useState("");
  const [PdfImage, setPdfImage] = useState("");
  const [XlsImage, setXlsImage] = useState("");

  const [optionsCurso, setOptionsCurso] = useState([]);
  const [optionsConvenios, setoptionsConvenios] = useState([]);

  const Navigate = useNavigate();

  const [Estado, setEstado] = useState(true);

  useEffect(() => {
    if (!Show) return;
    api
      .get("/curso/listar?procurar=")
      .then((res) => {
        const { data } = res;
        const resultsCurso = [];
        data.forEach((value) => {
          resultsCurso.push({
            label: value.nome,
            value: value.id,
          });
        });
        setOptionsCurso([{ label: " - ", value: null }, ...resultsCurso]);
      })
      .catch((err) => {
        console.log("deu erro X--> ", err);
      });
  }, [Show]);

  useEffect(() => {
    if (!Show) return;
    if (Curso == "") {
      console.log("Não ativou, curso vazio");
    } else {
      api
        .get(`/curso/listar-convenios?procurar=${Curso}`)
        .then((res) => {
          const data = res.data;
          const resultsConvenios = [
            {
              label: " - ",
              value: "",
            },
          ];
          data.forEach((value) => {
            resultsConvenios.push({
              label: value.convenio,
              value: value.convenio,
            });
          });
          setoptionsConvenios(resultsConvenios);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [Show, Curso]);

  const vazio = [{ label: "Selecione o curso", value: "" }];

  function setAllFalse() {
    setNome("");
    setRM("");
    setEmail("");
    setDataNascimento("");
    setDataInicio("");
    setDataTermino("");
    setCurso("");
    setConvenio("");
    setFileManual("");
    setNomeArquivoManual("");
    setTipoManual("");
    setFileImgManual("");
  }
  // Obtém a data atual
  const hoje = new Date();
  // Formata o ano com quatro dígitos
  const ano = hoje.getFullYear().toString().padStart(4, "0");
  // Formata o mês com dois dígitos
  const mes = (hoje.getMonth() + 1).toString().padStart(2, "0"); // getMonth() retorna 0-11, então adicione 1
  // Formata o dia com dois dígitos
  const dia = hoje.getDate().toString().padStart(2, "0");
  // Constrói a string no formato desejado
  const dataDeHojeFormatada = `${ano}-${mes}-${dia}`;

  async function HandleManualSubmit(e) {
    const data = {
      email: Email,
      rm: RM,
      nome: Nome,
      dt_nascimento: DataNascimento,
      dt_inicio: DataInicio,
      dt_termino: DataTermino,
      id_curso: Curso,
      convenio: Convenio,
      um_aluno: true,
      tituloDocumento: TipoManual,
    };
    // if (!FileManual) return Alert({tipo:"Erro2",mensagem:"Insira uma imagem!"});
    // Mapeia os campos obrigatórios e suas mensagens de erro
    const camposObrigatorios = {
      rm: "Insira o RM do aluno.",
      nome: "Insira o Nome do aluno.",
      email: "Insira o E-mail do aluno.",
      dt_nascimento: "Insira a Data de Nascimento.",
      id_curso: "Escolha um Curso.",
      convenio: "Escolha um Convênio.",
      dt_inicio: "Insira a Data de Início.",
      dt_termino: "Insira a Data de Término.",
    };
    // Verifica campos vazios
    for (const campo in camposObrigatorios) {
      if (!data[campo]) {
        Alert({ tipo: "Alert2", mensagem: camposObrigatorios[campo] });
        return;
      }
    }
    // Validações adicionais
    if (data.dt_nascimento >= dataDeHojeFormatada) {
      Alert({ tipo: "Alert2", mensagem: "Data de Nascimento Inválida." });
      return;
    }
    if (data.dt_inicio >= data.dt_termino) {
      Alert({ tipo: "Alert2", mensagem: "Data de Início ou Término Inválida." });
      return;
    }

    try {
      // Se passou em todas as validações, faz a requisição
      const formData = new FormData();

      Object.keys(data).map((key) => {
        formData.append(key, data[key]);
      });
      formData.append("file", FileManual);

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      const res = await api.post("/aluno/cadastrar", formData, config);
      if (res.data.mensagem) {
        await Alert({ tipo: "Sucesso2", mensagem: res.data.mensagem || "Aluno cadastrado com sucesso!" });
        setAllFalse();
        return setShow(false);
      }
    } catch (err) {
      console.error("Erro: ", err);
      Alert({ tipo: "Erro2", mensagem: err.response?.data?.erro?.split(".")[0] || "Erro ao cadastrar o aluno!" });
    }
  }

  return (
    <FirstCard Estado={Estado}>
      <Arroba
        onClick={() => {
          setAllFalse();
          setEstado(false);
          setTimeout(() => {
            setShow(false);
            setEstado(true);
          }, 400);
        }}
      >
        <Icone name={"X"} color={"#F0F0F0"} size={46} />
      </Arroba>
      <Form>
        <Heading>Cadastro do Aluno</Heading>
        <Field>
          <Mfield1>
            <Input marginleft="auto" marginright="auto" width="20vh" color="#FFFFFF" type={"text"} placeholder={"RM"} required={"true"} value={RM} event={(e) => setRM(e.target.value)} apenasNumeros={true} />
            <br />
            <br />
            <Input marginleft="auto" marginright="auto" width="20vh" color="#FFFFFF" type={"text"} placeholder={"Nome"} required={"true"} value={Nome} event={(e) => setNome(e.target.value)} />
            <br />
            <br />
            <Input marginleft="auto" marginright="auto" width="20vh" color="#FFFFFF" type={"email"} placeholder={"Email"} required={"true"} value={Email} event={(e) => setEmail(e.target.value)} />
            <br />
            <br />
            <Input marginleft="auto" marginright="auto" width="20vh" color="#FFFFFF" type={"date"} placeholder={"Nascimento"} required={"true"} value={DataNascimento} event={(e) => setDataNascimento(e.target.value)} />
          </Mfield1>
          <Mfield2>
            <InputSelect
              Label={"Curso"}
              Options={optionsCurso}
              Default={Curso}
              OnChange={(e) => {
                setCurso(e.target.value);
              }}
            />
            <br />
            <br />
            <InputSelect
              Label={"Convênio"}
              Options={Curso == "" ? vazio : optionsConvenios}
              Default={Convenio}
              OnChange={(e) => {
                setConvenio(e.target.value);
              }}
            />
            <br />
            <br />
            <Input marginleft="auto" marginright="auto" width="20vh" color="#FFFFFF" type={"date"} placeholder={"Início"} required={"true"} value={DataInicio} event={(e) => setDataInicio(e.target.value)} />
            <br />
            <br />
            <Input marginleft="auto" marginright="auto" width="20vh" color="#FFFFFF" type={"date"} placeholder={"Término"} required={"true"} value={DataTermino} event={(e) => setDataTermino(e.target.value)} />
          </Mfield2>
        </Field>
        <label style={{ color: "var(--background)", marginTop: "1.5rem" }}>Foto do Aluno</label>
        <br />
        <DropDiv2>
          {FileManual ? (
            <ImageContainer>
              <RemoveIcon
                onClick={() => {
                  setFileManual("");
                  setFileImgManual("");
                  setTipoManual("");
                  setNomeArquivoManual("");
                }}
              />
              <Image src={TipoManual.includes("image") ? FileImgManual : ""} alt="Erro" />
            </ImageContainer>
          ) : (
            <InputFileManual
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (e?.target?.files[0]?.type.includes("image") || e?.target?.files[0]?.type.includes("png") || e?.target?.files[0]?.type.includes("jpeg") || e?.target?.files[0]?.type.includes("jpg")) {
                  setFileImgManual(URL.createObjectURL(e?.target?.files[0]));
                  setFileManual(e?.target?.files[0]);
                  setTipoManual(e?.target?.files[0]?.type);
                  setNomeArquivoManual(e?.target?.files[0]?.name);
                } else {
                  Swal.fire({
                    title: "Atenção!",
                    text: "Formato não permitido!",
                    icon: "warning",
                  });
                }
              }}
            ></InputFileManual>
          )}
        </DropDiv2>
      </Form>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: 30,
          position: "absolute",
          width: "20%",
          top: "80%",
          left: "78%",
          heigh: "50vh",
        }}
      >
        <Button
          width="55%"
          height="40%"
          placeholder="Enviar"
          event={(e) => {
            HandleManualSubmit(e);
          }}
        />
      </div>
    </FirstCard>
  );
}
